import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'full' | 'icon';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({
  size = 'md',
  variant = 'full',
  className = '',
}) => {
  const sizeMap = {
    sm: { height: 32, fontSize: 16 },
    md: { height: 40, fontSize: 20 },
    lg: { height: 56, fontSize: 28 },
    xl: { height: 72, fontSize: 36 },
  };

  const dimensions = sizeMap[size];

  return (
    <div className={`coin-mfi-logo ${className}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}>
      {/* Logo Icon - Stylized Coin */}
      <svg
        width={dimensions.height}
        height={dimensions.height}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer Circle - Gold gradient */}
        <circle cx="24" cy="24" r="22" fill="url(#goldGradient)" />
        <circle cx="24" cy="24" r="22" stroke="#B45309" strokeWidth="1.5" />

        {/* Inner Circle */}
        <circle cx="24" cy="24" r="17" fill="#FEF3C7" opacity="0.3" />

        {/* Coin symbol - Stylized 'C' for Coin */}
        <path
          d="M24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38"
          stroke="#78350F"
          strokeWidth="3"
          strokeLinecap="round"
        />

        {/* Dollar sign integrated */}
        <path
          d="M24 14V34M20 18C20 18 21 16 24 16C27 16 28 17 28 19C28 21 26 22 24 22C22 22 20 23 20 25C20 27 21 28 24 28C27 28 28 26 28 26"
          stroke="#78350F"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Gradient Definition */}
        <defs>
          <linearGradient id="goldGradient" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#FCD34D" />
            <stop offset="50%" stopColor="#F59E0B" />
            <stop offset="100%" stopColor="#D97706" />
          </linearGradient>
        </defs>
      </svg>

      {/* Logo Text */}
      {variant === 'full' && (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
          <span
            style={{
              fontSize: `${dimensions.fontSize}px`,
              fontWeight: 700,
              color: '#171717',
              letterSpacing: '-0.02em',
            }}
          >
            Coin <span style={{ color: '#F59E0B' }}>MFI</span>
          </span>
          <span
            style={{
              fontSize: `${dimensions.fontSize * 0.5}px`,
              fontWeight: 500,
              color: '#737373',
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
            }}
          >
            Microfinance
          </span>
        </div>
      )}
    </div>
  );
};
